import { IScripFinancialsApi } from "../types/scrip-financials-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getScripFinancials = async (exchId: string, formattedSymbol: string) => {
  const response: IScripFinancialsApi = await request({
    method: "GET",
    url: `${API_PATHS.scripFinancials}?exchId=${exchId}&formattedSymbol=${formattedSymbol}`,
  });
  return response;
};
